import React, { useMemo } from "react";
import { useField } from "formik";
import { useEntities } from "@hooks/useEntities";
import { TransactionRuleActionFormSchema } from "../constants";
import { MultiEntityAccountSelect } from "../../../../accounts/MultiEntityAccountSelect";
import { useEntitiesFromFormCondition } from "../useEntitiesFromFormCondition";
import { useWorkspaceAccounts } from "../../../../../api/account.api";

interface Props {
    index: number;
}

export const AccountActionForm: React.FC<Props> = ({ index }) => {
    const [field, , helpers] = useField<
        TransactionRuleActionFormSchema["value"]
    >(`actions.${index}.value`);

    const entities = useEntitiesFromFormCondition();
    const allEntities = useEntities();
    const accounts = useWorkspaceAccounts();

    const selectedAccountName = useMemo(
        () =>
            field.value?.accountName ??
            accounts?.data?.find(
                (account) => account.id === field.value?.accountId,
            )?.name,
        [field, accounts],
    );

    const selectedEntityIds = useMemo(
        () =>
            entities.length > 0
                ? entities.map((e) => e.id)
                : allEntities.map((e) => e.id),
        [entities, allEntities],
    );

    if (entities.some((e) => e.isPersonal)) {
        return (
            <span>
                Personal entities are not supported for Account assignment
            </span>
        );
    }

    return (
        <MultiEntityAccountSelect
            selectedAccountName={selectedAccountName}
            onChange={(account) => {
                if (account?.isManuallyCreated) {
                    helpers.setValue({
                        accountId: account?.id ?? undefined,
                        accountName: undefined,
                    });
                } else {
                    helpers.setValue({
                        accountId: undefined,
                        accountName: account?.name ?? undefined,
                    });
                }
            }}
            dropdownKey={`transaction_account_${index}`}
            entityId={(entities[0] ?? allEntities[0]).id}
            selectedEntityIds={selectedEntityIds}
            size="xs"
        />
    );
};
